import { Image } from "@jewlr/storybook/core"
import { Checkbox } from "@jewlr/storybook/form"
import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import styled from "styled-components"

import {
  updateFilter,
  clearCategoryFilters,
  updateUniqueFilter,
} from "areas/collection/store/actions"
import { Box, Flex } from "components/common"
import withFilters from "areas/collection/hoc/with-filters"

const Container = styled(Box)`
  flex-wrap: wrap;
  display: flex;
  padding: 15px;
  width: 100%;
  ${({ theme }) => theme.mediaQueries.desktop`
    padding: 40px 0;
  `}
`
const Category = styled.div`
  flex-basis: 50%;
  margin-bottom: 25px;
  :nth-child(odd) {
    padding-right: 10px;
  }
  ${({ theme }) => theme.mediaQueries.desktop`
    flex-basis: 25%;
  `}
`

const CategoryName = styled.span`
  color: ${(props) => props.theme.colors.black};
  font-size: 14px;
  letter-spacing: 0.5px;
`
const DotIcon = styled(Box)`
  border-radius: 50%;
  height: 14px;
  margin-right: 8px;
  width: 14px;
  ${(props) =>
    props.vermeil &&
    `
    background-color: ${props.theme.colors.grey[20]};
    border: 4px solid #F8E7AD;
  `}
`

const categoryIcon = (category) => {
  const icon = category.icon_href
  if (icon && icon.dot_color) {
    return <DotIcon bg={`skus.${icon.dot_color}`} />
  } else if (category.name === "Vermeil") {
    return <DotIcon vermeil />
  } else if (category.belongs_to == "Stone Shape") {
    return (
      <Image
        alt={category.name}
        mr="5px"
        src={require(`images/collections/icons/stonecuts/${category.icon_tag}.svg`)}
        title={category.name}
        width="25px"
      />
    )
  } else {
    return ""
  }
}

const InternalFilterCategories = ({
  categories,
  hasIcons,
  setFilter,
  isUnique,
}) => {
  if (categories.length < 1) return null

  const [filterCategories, setFilterCategories] = useState(null)

  useEffect(() => {
    setFilterCategories(categories)
  })

  return (
    <Container contain>
      {categories.map((category, index) => {
        return (
          <Category key={`category${index}`}>
            <Checkbox
              checked={category.is_active_filter}
              disabled={category.disabled}
              onChange={(e) =>
                setFilter(
                  e,
                  category.filter_param,
                  isUnique,
                  category.belongs_to
                )
              }
              variant="primary"
            >
              <Flex
                alignItems="center"
                data-cy={`collection-filter-category-${category.name}`}
              >
                {hasIcons && categoryIcon(category)}
                <CategoryName>{category.name}</CategoryName>
              </Flex>
            </Checkbox>
          </Category>
        )
      })}
    </Container>
  )
}

InternalFilterCategories.propTypes = {
  categories: PropTypes.array,
}

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setFilter: (e, filter, unique, belongs_to) => {
      if (unique) {
        // deselect all other checkboxes in the category, then check the one requested
        dispatch(updateUniqueFilter({ filter, belongs_to }))
      } else {
        dispatch(updateFilter(filter))
      }
    },
  }
}

const FilterCategories = connect(
  mapStateToProps,
  mapDispatchToProps
)(withFilters(InternalFilterCategories))

export default FilterCategories
